import { isGoogleLanguage } from '@vocably/model';
import { searchConfig } from './constants';
/**
 * The language the visitor most likely wants translations in: the one they
 * last picked on this website, or else the first supported one their browser
 * asks for.
 */
export const getPreferredTargetLanguage = () => {
    const localStorageTargetLanguage = localStorage.getItem(searchConfig.targetLanguageLocalStorageKey);
    if (isGoogleLanguage(localStorageTargetLanguage !== null && localStorageTargetLanguage !== void 0 ? localStorageTargetLanguage : '')) {
        return localStorageTargetLanguage;
    }
    const navigatorLanguage = navigator.languages.find((language) => isGoogleLanguage(language));
    if (navigatorLanguage) {
        return navigatorLanguage;
    }
    const anotherNavigatorLanguage = navigator.language.split('-')[0];
    if (isGoogleLanguage(anotherNavigatorLanguage)) {
        return anotherNavigatorLanguage;
    }
    return 'en';
};
